import React, { useEffect } from 'react';

const PricingGridTemplateWidget = ({ selectedLayout, isTemplateId, widgetId, pricingTableTabData }) => {
    const {
        is_website_frontend,
    } = pricingTableTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/pricing-table/temp-css/PricingTableWidget.css`;
        if (widgetId) {
            link.setAttribute("pricing-table-data-dynamic-css", "pricing-table");
        } else {
            link.setAttribute("data-dynamic-css", "pricing-table");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="pricing-table"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    return (
        <>
            <div className={`pricing_table upgadeify pricing-table-pricing-grid-temp ${is_website_frontend}`}>
                <div className='pricing_table_grid'>
                    <div className='pricing_table_grid_header'>
                        <button className='pricing_grid_btn'>Billed Monthly</button>
                        <div className="Price_tooltip">
                            <button className='pricing_grid_btn_two'>Billed Yearly</button>
                            <span className="tooltipText">Save 15% 👍</span>
                        </div>
                    </div>
                    <div className="panel pricing-table">
                        <div className="pricing-plan">
                            <img src="/pricing-table/templates/pricing_basic.png" alt="" className="pricing-img" />
                            <h2 className="pricing-header" style={{ color: "#000" }}>Basic</h2>
                            <p style={{ color: "#111", fontSize:"12px" }}>Ideal for a small website/blog</p>
                            <ul className="pricing-features">
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>1 Website</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>20GB SSD Storage</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>5 Email Accounts</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Unlimited Bandwidth</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Free SSL</li>
                            </ul>
                            <span className="pricing-price" style={{ color: "#000", fontSize:"32px" }}>$2.99 <small style={{ color: "#000", fontSize:"16px" }}>/ month</small></span>
                            <span className="pricing-price" style={{ color: "red", fontSize:"12px" }}>ON SALE-SAVE 52%</span>
                            <a href="/" className="pricing-button">Pay monthly</a>
                        </div>
                        <div className="pricing-plan">
                            <img src="/pricing-table/templates/pricing_standard.png" alt="" className="pricing-img" />
                            <h2 className="pricing-header" style={{ color: "#000" }}>Standard</h2>
                            <p style={{ color: "#111", fontSize:"12px" }}>Perfect for a corporate</p>
                            <ul className="pricing-features">
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>3 Website</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>500GB SS Storage</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Unlimited Email Accounts</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Unlimited Bandwidth</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Free SSL</li>
                            </ul>
                            <span className="pricing-price" style={{ color: "#000", fontSize:"32px" }}>$5.99 <small style={{ color: "#000", fontSize:"16px" }}>/ month</small></span>
                            <span className="pricing-price" style={{ color: "red", fontSize:"12px" }}>ON SALE-SAVE 46%</span>
                            <a href="/" className="pricing-button">Pay monthly</a>
                        </div>
                        <div className="pricing-plan">
                            <img src="/pricing-table/templates/pricing_premium.png" alt="" className="pricing-img" />
                            <h2 className="pricing-header" style={{ color: "#000" }}>Premium</h2>
                            <p style={{ color: "#111", fontSize:"12px" }}>The best for high traffic websites</p>
                            <ul className="pricing-features">
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Unlimited Website</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>100GB SSD Storage</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>5 Email Accounts</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Unlimited Bandwidth</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Free SSL</li>
                            </ul>
                            <span className="pricing-price" style={{ color: "#000", fontSize:"32px" }}>$11.99 <small style={{ color: "#000", fontSize:"16px" }}>/ month</small></span>
                            <span className="pricing-price" style={{ color: "red", fontSize:"12px" }}>ON SALE-SAVE 42%</span>
                            <a href="/" className="pricing-button">Pay monthly</a>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default PricingGridTemplateWidget;
